// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import elementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css"
import VueAxios from "vue-axios";
import axios from "axios";
import store from "./store";
import "./style/index.less";



Vue.config.productionTip = false
Vue.prototype.$axios = axios;
//注册element
Vue.use(elementUI)


/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js